const areaData = [
    // 関東
    { name: "東京", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo" },
    { name: "東京 渋谷", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-shibuya" },
    { name: "東京 新宿", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-shinjuku" },
    { name: "東京 銀座", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-ginza" },
    { name: "東京 六本木", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-roppongi" },
    { name: "東京 池袋", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-ikebukuro" },
    { name: "東京 町田", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-machida" },
    { name: "東京 秋葉原", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-akihabara" },
    { name: "東京 表参道", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-omotesando" },
    { name: "東京 上野・御徒町", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-ueno-okachimachi" },
    { name: "東京 大井町", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-oimachi" },
    { name: "東京 五反田", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-gotanda" },
    { name: "東京 広尾", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-hiroo" },
    { name: "東京 目黒", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-meguro" },
    { name: "東京 中目黒", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-nakameguro" },
    { name: "東京 恵比寿", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-ebisu" },
    { name: "東京 調布", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-chofu" },
    { name: "東京 八王子", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-hachioji" },
    { name: "東京 立川", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-tachikawa" },
    { name: "東京 品川", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-shinagawa" },
    { name: "東京 麻布十番", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-azabujuban" },
    { name: "東京 下北沢", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-shimokitazawa" },
    { name: "東京 錦糸町", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-kinshicho" },
    { name: "東京 自由が丘", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-jiyugaoka" },
    { name: "東京 吉祥寺", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tokyo-kichijoji" },
    { name: "神奈川 横浜", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-kanagawa-yokohama" },
    { name: "神奈川 川崎", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-kanagawa-kawasaki" },
    { name: "神奈川 武蔵小杉", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-kanagawa-musashikosugi" },
    { name: "埼玉", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-saitama" },
    { name: "埼玉 大宮", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-saitama-omiya" },
    { name: "埼玉 浦和", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-saitama-urawa" },
    { name: "埼玉 越谷", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-saitama-koshigaya" },
    { name: "千葉", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-chiba" },
    { name: "群馬", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-gunma" },
    { name: "茨城", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-ibaraki" },
    { name: "茨城 水戸", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-ibaraki-mito" },
    { name: "栃木", region: "kanto", url: "https://ufit.co.jp/blogs/gym/personalgym-tochigi" },

    // 関西
    { name: "大阪", region: "kansai", url: "https://ufit.co.jp/blogs/gym/personalgym-osaka" },
    { name: "大阪 梅田", region: "kansai", url: "https://ufit.co.jp/blogs/gym/personalgym-osaka-umeda" },
    { name: "大阪 難波", region: "kansai", url: "https://ufit.co.jp/blogs/gym/personalgym-osaka-namba" },
    { name: "大阪 高槻", region: "kansai", url: "https://ufit.co.jp/blogs/gym/personalgym-osaka-takatsuki" },
    { name: "大阪 堺", region: "kansai", url: "https://ufit.co.jp/blogs/gym/personalgym-osaka-sakai" },
    { name: "京都", region: "kansai", url: "https://ufit.co.jp/blogs/gym/personalgym-kyoto" },
    { name: "兵庫 神戸", region: "kansai", url: "https://ufit.co.jp/blogs/gym/personalgym-hyogo-kobe" },
    { name: "滋賀", region: "kansai", url: "https://ufit.co.jp/blogs/gym/personalgym-shiga" },
    { name: "奈良", region: "kansai", url: "https://ufit.co.jp/blogs/gym/personalgym-nara" },
    { name: "和歌山", region: "kansai", url: "https://ufit.co.jp/blogs/gym/personalgym-wakayama" },

    // 中部
    { name: "愛知", region: "chubu", url: "https://ufit.co.jp/blogs/gym/personalgym-aichi" },
    { name: "愛知 名古屋", region: "chubu", url: "https://ufit.co.jp/blogs/gym/personalgym-aichi-nagoya" },
    { name: "愛知 豊田", region: "chubu", url: "https://ufit.co.jp/blogs/gym/personalgym-aichi-toyota" },
    { name: "静岡", region: "chubu", url: "https://ufit.co.jp/blogs/gym/personalgym-shizuoka" },
    { name: "岐阜", region: "chubu", url: "https://ufit.co.jp/blogs/gym/personalgym-gifu" },
    { name: "三重", region: "chubu", url: "https://ufit.co.jp/blogs/gym/personalgym-mie" },
    { name: "山梨", region: "chubu", url: "https://ufit.co.jp/blogs/gym/personalgym-yamanashi" },
    { name: "長野", region: "chubu", url: "https://ufit.co.jp/blogs/gym/personalgym-nagano" },
    { name: "新潟", region: "chubu", url: "https://ufit.co.jp/blogs/gym/personalgym-niigata" },
    { name: "富山", region: "chubu", url: "https://ufit.co.jp/blogs/gym/personalgym-toyama" },
    { name: "石川", region: "chubu", url: "https://ufit.co.jp/blogs/gym/personalgym-ishikawa" },
    { name: "福井", region: "chubu", url: "https://ufit.co.jp/blogs/gym/personalgym-fukui" },

    // 中国
    { name: "岡山", region: "chugoku", url: "https://ufit.co.jp/blogs/gym/personalgym-okayama" },
    { name: "広島", region: "chugoku", url: "https://ufit.co.jp/blogs/gym/personalgym-hiroshima" },
    { name: "鳥取", region: "chugoku", url: "https://ufit.co.jp/blogs/gym/personalgym-tottori" },
    { name: "島根", region: "chugoku", url: "https://ufit.co.jp/blogs/gym/personalgym-shimane" },
    { name: "山口", region: "chugoku", url: "https://ufit.co.jp/blogs/gym/personalgym-yamaguchi" },

    // 四国
    { name: "徳島", region: "shikoku", url: "https://ufit.co.jp/blogs/gym/personalgym-tokushima" },
    { name: "香川", region: "shikoku", url: "https://ufit.co.jp/blogs/gym/personalgym-kagawa" },
    { name: "愛媛", region: "shikoku", url: "https://ufit.co.jp/blogs/gym/personalgym-ehime" },
    { name: "高知", region: "shikoku", url: "https://ufit.co.jp/blogs/gym/personalgym-kochi" },

    // 九州・沖縄
    { name: "福岡", region: "kyushu", url: "https://ufit.co.jp/blogs/gym/personalgym-fukuoka" },
    { name: "福岡 久留米", region: "kyushu", url: "https://ufit.co.jp/blogs/gym/personalgym-fukuoka-kurume" },
    { name: "福岡 北九州", region: "kyushu", url: "https://ufit.co.jp/blogs/gym/personalgym-fukuoka-kitakyushu" },
    { name: "佐賀", region: "kyushu", url: "https://ufit.co.jp/blogs/gym/personalgym-saga" },
    { name: "長崎", region: "kyushu", url: "https://ufit.co.jp/blogs/gym/personalgym-nagasaki" },
    { name: "熊本", region: "kyushu", url: "https://ufit.co.jp/blogs/gym/personalgym-kumamoto" },
    { name: "大分", region: "kyushu", url: "https://ufit.co.jp/blogs/gym/personalgym-oita" },
    { name: "宮崎", region: "kyushu", url: "https://ufit.co.jp/blogs/gym/personalgym-miyazaki" },
    { name: "鹿児島", region: "kyushu", url: "https://ufit.co.jp/blogs/gym/personalgym-kagoshima" },
    { name: "沖縄", region: "kyushu", url: "https://ufit.co.jp/blogs/gym/personalgym-okinawa" },

    // 東北
    { name: "宮城 仙台", region: "tohoku", url: "https://ufit.co.jp/blogs/gym/personalgym-miyagi-sendai" },
    { name: "青森", region: "tohoku", url: "https://ufit.co.jp/blogs/gym/personalgym-aomori" },
    { name: "秋田", region: "tohoku", url: "https://ufit.co.jp/blogs/gym/personalgym-akita" },
    { name: "岩手", region: "tohoku", url: "https://ufit.co.jp/blogs/gym/personalgym-iwate" },
    { name: "山形", region: "tohoku", url: "https://ufit.co.jp/blogs/gym/personalgym-yamagata" },
    { name: "福島", region: "tohoku", url: "https://ufit.co.jp/blogs/gym/personalgym-fukushima" },

    // 北海道
    { name: "北海道 札幌", region: "hokkaido", url: "https://ufit.co.jp/blogs/gym/personalgym-hokkaido-sapporo" },
    { name: "北海道 帯広", region: "hokkaido", url: "https://ufit.co.jp/blogs/gym/personalgym-hokkaido-obihiro" },
    { name: "北海道 旭川", region: "hokkaido", url: "https://ufit.co.jp/blogs/gym/personalgym-hokkaido-asahikawa" },
    { name: "北海道 函館", region: "hokkaido", url: "https://ufit.co.jp/blogs/gym/personalgym-hokkaido-hakodate" }
];

// 地域ごとの都道府県データ
const prefecturesByRegion = {
    hokkaido: [
        { name: '札幌', url: 'https://ufit.co.jp/blogs/gym/personalgym-hokkaido-sapporo' },
        { name: '帯広', url: 'https://ufit.co.jp/blogs/gym/personalgym-hokkaido-obihiro' },
        { name: '旭川', url: 'https://ufit.co.jp/blogs/gym/personalgym-hokkaido-asahikawa' },
        { name: '函館', url: 'https://ufit.co.jp/blogs/gym/personalgym-hokkaido-hakodate' }
    ],
    tohoku: [
        { name: '青森', url: 'https://ufit.co.jp/blogs/gym/personalgym-aomori' },
        { name: '秋田', url: 'https://ufit.co.jp/blogs/gym/personalgym-akita' },
        { name: '岩手', url: 'https://ufit.co.jp/blogs/gym/personalgym-iwate' },
        { name: '宮城', url: 'https://ufit.co.jp/blogs/gym/personalgym-miyagi-sendai' },
        { name: '山形', url: 'https://ufit.co.jp/blogs/gym/personalgym-yamagata' },
        { name: '福島', url: 'https://ufit.co.jp/blogs/gym/personalgym-fukushima' }
    ],
    kanto: [
        {
            name: '東京',
            url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo',
            subAreas: [
                { name: '東京', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo' },
                { name: '渋谷', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-shibuya' },
                { name: '新宿', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-shinjuku' },
                { name: '銀座', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-ginza' },
                { name: '六本木', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-roppongi' },
                { name: '池袋', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-ikebukuro' },
                { name: '町田', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-machida' },
                { name: '秋葉原', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-akihabara' },
                { name: '表参道', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-omotesando' },
                { name: '上野・御徒町', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-ueno-okachimachi' },
                { name: '大井町', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-oimachi' },
                { name: '五反田', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-gotanda' },
                { name: '広尾', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-hiroo' },
                { name: '目黒', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-meguro' },
                { name: '中目黒', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-nakameguro' },
                { name: '恵比寿', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-ebisu' },
                { name: '調布', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-chofu' },
                { name: '八王子', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-hachioji' },
                { name: '立川', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-tachikawa' },
                { name: '品川', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-shinagawa' },
                { name: '麻布十番', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-azabujuban' },
                { name: '下北沢', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-shimokitazawa' },
                { name: '錦糸町', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-kinshicho' },
                { name: '自由が丘', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-jiyugaoka' },
                { name: '吉祥寺', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokyo-kichijoji' }
            ]
        },
        {
            name: '神奈川',
            url: 'https://ufit.co.jp/blogs/gym/personalgym-kanagawa-yokohama',
            subAreas: [
                { name: '横浜', url: 'https://ufit.co.jp/blogs/gym/personalgym-kanagawa-yokohama' },
                { name: '川崎', url: 'https://ufit.co.jp/blogs/gym/personalgym-kanagawa-kawasaki' },
                { name: '武蔵小杉', url: 'https://ufit.co.jp/blogs/gym/personalgym-kanagawa-musashikosugi' }
            ]
        },
        {
            name: '埼玉',
            url: 'https://ufit.co.jp/blogs/gym/personalgym-saitama',
            subAreas: [
                { name: '埼玉', url: 'https://ufit.co.jp/blogs/gym/personalgym-saitama' },
                { name: '大宮', url: 'https://ufit.co.jp/blogs/gym/personalgym-saitama-omiya' },
                { name: '浦和', url: 'https://ufit.co.jp/blogs/gym/personalgym-saitama-urawa' },
                { name: '越谷', url: 'https://ufit.co.jp/blogs/gym/personalgym-saitama-koshigaya' }
            ]
        },
        {
            name: '千葉',
            url: 'https://ufit.co.jp/blogs/gym/personalgym-chiba',
        },
        { name: '群馬', url: 'https://ufit.co.jp/blogs/gym/personalgym-gunma' },
        {
            name: '茨城',
            url: 'https://ufit.co.jp/blogs/gym/personalgym-ibaraki',
            subAreas: [
                { name: '茨城', url: 'https://ufit.co.jp/blogs/gym/personalgym-ibaraki' },
                { name: '水戸', url: 'https://ufit.co.jp/blogs/gym/personalgym-ibaraki-mito' }
            ]
        },
        { name: '栃木', url: 'https://ufit.co.jp/blogs/gym/personalgym-tochigi' }
    ],
    chubu: [
        {
            name: '愛知',
            url: 'https://ufit.co.jp/blogs/gym/personalgym-aichi',
            subAreas: [
                { name: '愛知', url: 'https://ufit.co.jp/blogs/gym/personalgym-aichi' },
                { name: '名古屋', url: 'https://ufit.co.jp/blogs/gym/personalgym-aichi-nagoya' },
                { name: '豊田', url: 'https://ufit.co.jp/blogs/gym/personalgym-aichi-toyota' }
            ]
        },
        { name: '静岡', url: 'https://ufit.co.jp/blogs/gym/personalgym-shizuoka' },
        { name: '岐阜', url: 'https://ufit.co.jp/blogs/gym/personalgym-gifu' },
        { name: '三重', url: 'https://ufit.co.jp/blogs/gym/personalgym-mie' },
        { name: '山梨', url: 'https://ufit.co.jp/blogs/gym/personalgym-yamanashi' },
        { name: '長野', url: 'https://ufit.co.jp/blogs/gym/personalgym-nagano' },
        { name: '新潟', url: 'https://ufit.co.jp/blogs/gym/personalgym-niigata' },
        { name: '富山', url: 'https://ufit.co.jp/blogs/gym/personalgym-toyama' },
        { name: '石川', url: 'https://ufit.co.jp/blogs/gym/personalgym-ishikawa' },
        { name: '福井', url: 'https://ufit.co.jp/blogs/gym/personalgym-fukui' }
    ],
    kansai: [
        {
            name: '大阪',
            url: 'https://ufit.co.jp/blogs/gym/personalgym-osaka',
            subAreas: [
                { name: '大阪', url: 'https://ufit.co.jp/blogs/gym/personalgym-osaka' },
                { name: '梅田', url: 'https://ufit.co.jp/blogs/gym/personalgym-osaka-umeda' },
                { name: '難波', url: 'https://ufit.co.jp/blogs/gym/personalgym-osaka-namba' },
                { name: '高槻', url: 'https://ufit.co.jp/blogs/gym/personalgym-osaka-takatsuki' },
                { name: '堺', url: 'https://ufit.co.jp/blogs/gym/personalgym-osaka-sakai' }
            ]
        },
        { name: '京都', url: 'https://ufit.co.jp/blogs/gym/personalgym-kyoto' },
        { name: '兵庫', url: 'https://ufit.co.jp/blogs/gym/personalgym-hyogo-kobe' },
        { name: '滋賀', url: 'https://ufit.co.jp/blogs/gym/personalgym-shiga' },
        { name: '奈良', url: 'https://ufit.co.jp/blogs/gym/personalgym-nara' },
        { name: '和歌山', url: 'https://ufit.co.jp/blogs/gym/personalgym-wakayama' }
    ],
    chugoku: [
        { name: '岡山', url: 'https://ufit.co.jp/blogs/gym/personalgym-okayama' },
        { name: '広島', url: 'https://ufit.co.jp/blogs/gym/personalgym-hiroshima' },
        { name: '鳥取', url: 'https://ufit.co.jp/blogs/gym/personalgym-tottori' },
        { name: '島根', url: 'https://ufit.co.jp/blogs/gym/personalgym-shimane' },
        { name: '山口', url: 'https://ufit.co.jp/blogs/gym/personalgym-yamaguchi' }
    ],
    shikoku: [
        { name: '徳島', url: 'https://ufit.co.jp/blogs/gym/personalgym-tokushima' },
        { name: '香川', url: 'https://ufit.co.jp/blogs/gym/personalgym-kagawa' },
        { name: '愛媛', url: 'https://ufit.co.jp/blogs/gym/personalgym-ehime' },
        { name: '高知', url: 'https://ufit.co.jp/blogs/gym/personalgym-kochi' }
    ],
    kyushu: [
        {
            name: '福岡',
            url: 'https://ufit.co.jp/blogs/gym/personalgym-fukuoka',
            subAreas: [
                { name: '福岡', url: 'https://ufit.co.jp/blogs/gym/personalgym-fukuoka' },
                { name: '久留米', url: 'https://ufit.co.jp/blogs/gym/personalgym-fukuoka-kurume' },
                { name: '北九州', url: 'https://ufit.co.jp/blogs/gym/personalgym-fukuoka-kitakyushu' }
            ]
        },
        { name: '佐賀', url: 'https://ufit.co.jp/blogs/gym/personalgym-saga' },
        { name: '長崎', url: 'https://ufit.co.jp/blogs/gym/personalgym-nagasaki' },
        { name: '熊本', url: 'https://ufit.co.jp/blogs/gym/personalgym-kumamoto' },
        { name: '大分', url: 'https://ufit.co.jp/blogs/gym/personalgym-oita' },
        { name: '宮崎', url: 'https://ufit.co.jp/blogs/gym/personalgym-miyazaki' },
        { name: '鹿児島', url: 'https://ufit.co.jp/blogs/gym/personalgym-kagoshima' },
        { name: '沖縄', url: 'https://ufit.co.jp/blogs/gym/personalgym-okinawa' }
    ]
}; 